import React, { useEffect, useRef, useState } from 'react'
import parse from 'html-react-parser';
import nl2br from 'nl2br';
import constant from '../../../../constant';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
const Index = ({ state, onChange, isFinalSubmitting, setIsFinalSubmitting, onSubmit, history, siteManager }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const sectionRefs = useRef([]);
    useEffect(() => {
        const handleScroll = () => {
            const offsets = sectionRefs.current.map((ref) =>
                ref ? ref.getBoundingClientRect().top : 0
            );
            const visibleIndex = offsets.findIndex((top) => top >= 0 && top < 300);
            if (visibleIndex !== -1 && visibleIndex !== activeIndex) {
                setActiveIndex(visibleIndex);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeIndex]);

    return (
        <div className="row">
            <div className="col-md-3">
                <div className="scroll-left-aside">
                    <h4>Check List Form Information </h4>
                    <ul className="scroll-left-list">
                        {state.map((section, index) => {
                            return (
                                <li key={section.id || index}>
                                    <a href="#"
                                        className={activeIndex === index ? 'active' : ''}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const target = sectionRefs.current[index];
                                            if (target) {
                                                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                setActiveIndex(index);
                                            }
                                        }}>
                                        <span>{String.fromCharCode(65 + index)}</span> {section.name}
                                    </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
            <div className="col-md-9 ">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p>ITEM DESCRIPTION</p>
                                </td>
                                <td className="hd-s2 w200 pd10">
                                    <p>REMARKS</p>
                                </td>
                                <td className="hd-s2 pd10" colSpan={2}>
                                    <p>
                                        <a name="bookmark0">‌</a>STATUS OF COMPLETION{" "}
                                        <a name="bookmark1">‌</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1" />
                                </td>
                                <td className="td-s2" />
                                <td />
                                <td className="check-td-s3 text-center">Yes</td>
                                <td className="check-td-s3 text-center">No</td>
                            </tr>

                            {state.map((section, sectionIndex) => (
                                <React.Fragment key={section.id || sectionIndex}>
                                    {/* Section Heading */}
                                    <tr id={`section${sectionIndex}`}
                                        ref={(el) => (sectionRefs.current[sectionIndex] = el)}>
                                        <td className="td-s1 td-s1-heading" colSpan={5}>
                                            <p className="s1">{String.fromCharCode(65 + sectionIndex)}. {section.name}</p>
                                        </td>
                                    </tr>

                                    {/* Items in Section */}
                                    {section.items.map((item, itemIndex) => {
                                        return (
                                            < tr className='remark-tr2-box' >
                                                <td className="td-s1">
                                                    <p className="s1">{itemIndex + 1}.</p>
                                                </td>
                                                <td className="td-s2">
                                                    <p className="s2">
                                                        {parse(nl2br(item.label))}
                                                    </p>
                                                </td>
                                                <td >
                                                    <p className="s1">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder='Enter Remarks...'

                                                            id="formCheck1"
                                                            value={item.remarks}
                                                            onChange={(e) =>
                                                                onChange(sectionIndex, itemIndex, 'remarks', e.target.value)
                                                            }
                                                        />
                                                    </p>
                                                </td>
                                                <td className="td-form-check">
                                                    <div className="form-check">


                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={item.statusOfCompletion === 'yes'}
                                                            onChange={() =>
                                                                onChange(sectionIndex, itemIndex, 'statusOfCompletion', item.statusOfCompletion === 'yes' ? '' : 'yes')
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                                <td className="td-form-check">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={item.statusOfCompletion === 'no'}
                                                            onChange={() =>
                                                                onChange(sectionIndex, itemIndex, 'statusOfCompletion', item.statusOfCompletion === 'no' ? '' : 'no')
                                                            }
                                                        />
                                                    </div>
                                                </td>

                                            </tr>
                                        )
                                    }
                                    )}

                                </React.Fragment>
                            ))}


                        </tbody>
                    </table>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <table className="table-bottom-sig">
                            <tbody>
                                <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Signature of Site Manager:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue={siteManager}
                                            />
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="final-checkbox">
                            <div class="form-check mt-2">
                                <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                                <label class="form-check-label" for="productdiscountCheck1">Send New Building Pre Launching Check List to Office for Review</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            onClick={() => { onSubmit() }}
                            className="btn btn-success"
                            style={{
                                backgroundImage:
                                    "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage:
                                    "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.production.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)